import React from "react";
import SEO from "../SEO";
import { useLanguage } from "../../i18n";


const NotFound = () => {
  const { t } = useLanguage();

  return (
    <div style={{ textAlign: "center", padding: "4rem" }}>
      <SEO
        title={t("seo.notFoundTitle")}
        description={t("seo.notFoundDescription")}
        url="https://fixanor.com/404"
        image="https://fixanor.com/images/hero-image-webp.webp"
      />
      <h1>{t("notFound.heading")}</h1>
      <p>{t("notFound.text")}</p>
    </div>
  );
};

export default NotFound;
